// F7: Villagr was once called "settlr". These old paths redirect to the game (edge: public/_redirects; SPA: routes/index.tsx).
export const LEGACY_VILLAGR_PATHS = ["/games/settlr", "/games/settlr/*", "/settlr", "/settlr/*"] as const;

/** Where a legacy path goes: the game route, keeping the query (realm / playtest links) and hash. */
export function legacyVillagrTarget(search: string, hash: string): string {
  return `/games/villagr${search ?? ""}${hash ?? ""}`;
}
